import styled from "styled-components";

export const Container = styled.div`
    padding: 0; 
    margin: 0 auto;
    max-width: 1280px;
`
